const STORAGE_KEY = 'igv_percent';
const DEFAULT_IGV_PERCENT = 18;

export const getIgvPercent = (): number => {
  const stored = localStorage.getItem(STORAGE_KEY);
  const value = stored !== null ? Number(stored) : DEFAULT_IGV_PERCENT;
  if (isNaN(value) || value < 0 || value > 100) return DEFAULT_IGV_PERCENT;
  return value;
};

export const setIgvPercent = (percent: number): void => {
  localStorage.setItem(STORAGE_KEY, String(percent));
};

export const getIgvRate = (): number => getIgvPercent() / 100;

export const getIgvLabel = (): string => `IGV (${getIgvPercent()}%)`;
